<template>
    <div>
      <div class="main-container">
      <tl-header type="h1">
        <div>Tax outside Payroll </div>
      </tl-header>
        <div class="d-payroll__group">
        <div class="d-heading2 d-marginBottom d-flexbox"></div>
      </div>
      <div v-if="true">
        <div class="download-btn">
          <div class="download-btn-container">
              <img src="@/assets/download.svg"  class="img" />
              <span class="text" @click="downloadOnsiteTemplate">Download Template</span>
              <loading-animation v-show="showLoader"></loading-animation>
           </div>
        </div>
        <div class="margintop-20">
          <upload :tobucket="false" @change="onUploadOnsiteTemplate($event)"></upload>
        </div>
      </div>
      <pop-up-message
        v-if="showSuccessBulkUploadMsg"
        :message="responseMsg"
        btnText="Back"
        @back="back"
      ></pop-up-message>
      <div class="lock-list">
        <br />
        <tl-checkbox label="Tax outside Payroll List" @change="(bool)=>{locklist(bool)}"></tl-checkbox>
      </div>
      <footer>
      <bottom-action-container>
        <btn-skip @navClicked="skip" />
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Cancel" type="secondary" @click="cancel" />
            <btn text="Next" :disabled="!isLopsLocked" type="primary" @click="next" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </footer>
      <!-- <div class="line"></div>
        <br />
        <br />
        <btn-grp class="btnGrp">
          <btn text="Cancel" type="secondary" @click="cancel" />
          <btn text="Next" :disabled="!isLopsLocked" type="primary" @click="next" />
        </btn-grp> -->
      </div>
    </div>
  </template>
  <script>
  import { mapActions, mapGetters, mapState } from "vuex";
  import { createDecipheriv } from 'crypto';
  import SearchDropdown from "@/components/TlSearchDropdown.vue";
  import selectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
  import * as constants from "@/apis/constants.js";
  import { api_variables } from "@/apis/variables.js";
  import axios from "axios";
  import {S3} from "aws-sdk";
  export default {
    name: "LopsandRlops",
    components: { SearchDropdown, selectedEmployeeCard, },
    data() {
      return {
        showIntro: true,
        isLopsLocked: false,
        showLoader: false,
        bulkUploadTemplateUrl:'https://paylief.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/Template- LoP_RLoP.xlsx',
        bulkUploadUrl: api_variables.SERVICE_LOP_RLOP_UPLOAD_TEMPLATE,
        errmsg: "",
        toast: false,
        responseMsg: "",
        showEmpDetails: false,
        showSuccessBulkUploadMsg: false,
        uploadMethod: "manualUpload",
        auto_suggestions: false,
        filterEmpData: [],
        empName: "",
        empId: null,
        typeOfLeave: null,
        noOfDays: "",
        month:"",
        selectDate: "",
        lopMonthCount: null,
        rlopMonthCount: null,
        lopMonthCountArray: [],
        rlopMonthCountArray: [],
        typeOptions: [],
        lockList: "",
        lopCount: 0,
        rlopCount: 0,
        lopRlopType: null,
        showDatePicker: false,
        months:[
           "April", "May", "June", "July", "August",
          "September", "October", "November", "December", "January", "February", "March",
        ],
        dateMonths: ["January", "February", "March","April", "May", "June", "July", "August",
          "September", "October", "November", "December",],
        monthOptions: [
          {
            key: "01",
            value: "jan"
          },
          {
            key: "02",
            value: "feb"
          },
          {
            key: "03",
            value: "mar"
          },
          {
            key: "04",
            value: "apr"
          },
          {
            key: "05",
            value: "may"
          },
          {
            key: "06",
            value: "jun"
          },
          {
            key: "07",
            value: "jul"
          },
          {
            key: "08",
            value: "aug"
          },
          {
            key: "09",
            value: "sep"
          },
          {
            key: "10",
            value: "oct"
          },
          {
            key: "11",
            value: "nov"
          },
          {
            key: "12",
            value: "dec"
          }
        ],
        employeeData: [],
        payrollMonthIndex: 0,
        countObj: {
          payGroupsSelected: 0,
          totalEmployeesSelected: 0,
          eligibleEmployeesSelected: 0,
          totalPayGroups: 0,
          totalEmployees: 0,
          totalEligibleEmployees: 0
        }
      };
    },
    activated() {
      this.fetchLopSetting();
      this.setConstantsData();
      this.refresh();
      this.fetchAll();
      this.fetchPaygroupsUpdatedData();
      this.setMonth();
      this.setData();
    },
    mounted() {
      this.fetchLopSetting();
      this.setConstantsData();
      this.refresh();
      this.fetchAll();
      this.fetchPaygroupsUpdatedData();
      this.setMonth();
      this.setData();
    },
    computed: {
      ...mapGetters({
        getleid: "onboard/legal_entities/legal_entity_ID"
      }),
      ...mapState({
        lopRlopData: state => state.payroll.lopsandrlops.lopsandrlops,
        employeesJoiningsData: state => state.payroll.joinings.joinings, //fetch employees data
        selectedPayGroupsData: state => state.payroll.paygroups.data,
        payGroupsData: state => state.payroll.paygroups.payGroups,
        payrollMonth: state => state.payroll.runpayroll.payrollMonth,
        payrollYear: state => state.payroll.runpayroll.payrollYear
      }),
      le_id() {
        if (this.$route.params.entity_index)
          return this.getleid(this.$route.params.entity_index);
        else return this.getleid(0);
      }
    },
    methods: {
      ...mapActions({
        act_fetch_paygroups_updated_data: "payroll/paygroups/fetchAll",
        act_fetchAll: "payroll/lopsandrlops/fetchLopandRlop",
        act_create: "payroll/lopsandrlops/create",
        act_fetchAllEmployees: "globalapi/globalemployees/fetchAll",
        act_upload_template:
          "dashboard/payroll/utilities/uploadloprlop/uploadTemplate",
        act_taxafterPayroll_upload_template:
          "dashboard/payroll/utilities/uploadloprlop/uploadTaxoutsidepayrollTemplate",
        fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
        act_fetch_lop_setting: "onboard/settings/payroll_computation/fetchAll",
        act_get_lop_rlop_data: "payroll/lopsandrlops/getLopData",
        act_download_taxoutsidepayroll: "payroll/lopsandrlops/downloadTaxoutsidePayrollTemplates",
        getPreSignedUrl: "payroll/lopsandrlops/createPreSigned",

      }),
      lockingLops(event) {
        this.isLopsLocked = event;
      },
      skip() {
      this.refresh();
      this.$router.push({
        path: `/payroll/run/${this.$route.params.entity_index}/summary`
      });
    },
      cancel() {
        this.$router.push({
          path: `/payroll/run/${
            this.$route.params.entity_index ? this.$route.params.entity_index : 0
          }/variableEarnings`
        });
      },
      /** Navigation */
      next() {
        this.isLopsLocked=false;
        this.$router.push({
          path: `/payroll/run/${
            this.$route.params.entity_index ? this.$route.params.entity_index : 0
          }/summary`,
          
        });
      },
      // function for onsite template
      async downloadOnsiteTemplate() {
        try {
        let data={
           le_id : this.le_id,
          }
          console.log(data);
          let res = await this.act_download_taxoutsidepayroll(data);
          console.log(res);
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
      async preSignedUrlFunction() {
  try {
    let res = await this.getPreSignedUrl({
      url: this.bulkUploadTemplateUrl
    });
    if (res.data.payload && res.data.payload.iv && res.data.payload.encryptedPacket) {
      const decryptedLink = await this.decrypt(res.data.payload);
      return decryptedLink;
    } else {
      console.log('Invalid payload structure');
      return null;
    } 
  } catch (e) {
    console.log('Error in preSignedUrlFunction:', e);
    return null; 
  }
},
async downloadUrl() {
      try {
        const downloadLink = await this.preSignedUrlFunction();
        if (downloadLink) {
          let url = JSON.parse(downloadLink);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "LOP_R_LOP.xls"); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          console.log('Failed to retrieve the download link.');
        }
      } catch (e) {
        console.error('Error during download:', e);
      }
    },
    async decrypt(payload){
    const key = process.env.VUE_APP_PAYSLIP_SECRET;
    const decipher = createDecipheriv('aes-256-cbc', key, Buffer.from(payload.iv, 'hex'));
    const decrypted = Buffer.concat([
        decipher.update(payload.encryptedPacket, 'base64'),
        decipher.final()
    ]);

    return decrypted.toString();
},
      
      /** To set the drop down options from constants file */
      setConstantsData() {
        try {
          this.typeOptions =
            constants.LossReverseLossOfPayConstants.lopRLopTypeList;
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
      /** To clear the selected employee data */
      clearEmployee() {
        this.empName = null;
        this.empId = null;
      },
      /** Function to fetch the employees available in that LE by name */
      async searchEmployeesByName(val) {
        try {
          let res = await this.fetchEmployeeByLeAndName({
            le_id: this.le_id,
            key: val
          });
          if (res.data.status) {
            this.employeeData = res.data.payload;
          }
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
      async selectedEmp(emp) {
        try {
          ////console.log("empObj", emp);
          this.data = emp;
          // //console.log("inside selected employe",emp)
          this.empId = emp.id;
          this.empName = emp.name;
          this.showEmpDetails = true;
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      },
      close() {
        this.showEmpDetails = false;
        this.month = null;
        this.lopMonthCount = null;
        this.rlopMonthCount = null;
        this.lopMonthCountArray = null;
        this.rlopMonthCountArray = null;
      },
      
      setMonth(){
        const index = this.months.indexOf(this.payrollMonth)
        this.months = this.months.slice(0, index+1);
        this.payrollMonthIndex = this.dateMonths.indexOf(this.payrollMonth) + 2;
      },
      /** BULK UPLOAD functionality */
       
      async onUploadTemplate(event) {
        var today = new Date();
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        let currentMonthEnum = this.payrollMonth.toLowerCase().substring(0,3);
        let year = this.payrollYear;
        let formData = new FormData();
        formData.append("file", event);
        formData.append("le_id", this.le_id);
        formData.append(
          "financial_year", year
        );
        formData.append("processing_month", currentMonthEnum);
        this.$root._data.isSaving = true;
        try {
          let res = await this.act_upload_template(formData);
          if (res.data.status) {
            this.responseMsg = res.data.message ? res.data.message : "";
            this.showSuccessBulkUploadMsg = true;
          }
          setTimeout(() => {
            this.$root._data.isSaving = false;
          }, 500);
        } catch (err) {
          this.$root._data.isSaving = false;
          this.toast = true;
          this.errmsg = err;
        }
      },
      
      async onUploadOnsiteTemplate(event) {
        var today = new Date();
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        let currentMonthEnum = this.payrollMonth.toLowerCase().substring(0,3);
        let year = this.payrollYear;
        let formData = new FormData();
        formData.append("file", event);
        formData.append("le_id", this.le_id);
        formData.append(
          "year", year
        );
        formData.append("month", currentMonthEnum);
        this.$root._data.isSaving = true;
        try {
          let res = await this.act_taxafterPayroll_upload_template(formData);
          if (res.data.status) {
            this.responseMsg = res.data.message ? res.data.message : "";
            this.showSuccessBulkUploadMsg = true;
          }
          setTimeout(() => {
            this.$root._data.isSaving = false;
          }, 500);
        } catch (err) {
          this.$root._data.isSaving = false;
          this.toast = true;
          this.errmsg = err;
        }
      },
      
      // async onUploadTemplate(res) {
      //   try {
      //     if (res.data && res.data.status) {
      //       this.responseMsg = res.data.message ? res.data.message : "";
      //       this.showSuccessBulkUploadMsg = true;
      //     } else {
      //       this.toast = true;
      //       this.errmsg = res.message;
      //     }
      //   } catch (err) {
      //     this.$root._data.isSaving = false;
      //     this.toast = true;
      //     this.errmsg = err;
      //   }
      // },
      
      /** Function to get the selected month enum by ID*/
      getCurrentMonthEnum(selectedMonth) {
        let selectedMonthEnum = "";
        switch (selectedMonth) {
          case "01":
            selectedMonthEnum = "jan";
            break;
          case "02":
            selectedMonthEnum = "feb";
            break;
          case "03":
            selectedMonthEnum = "mar";
            break;
          case "04":
            selectedMonthEnum = "apr";
            break;
          case "05":
            selectedMonthEnum = "may";
            break;
          case "06":
            selectedMonthEnum = "jun";
            break;
          case "07":
            selectedMonthEnum = "jul";
            break;
          case "08":
            selectedMonthEnum = "aug";
            break;
          case "09":
            selectedMonthEnum = "sep";
            break;
          case "10":
            selectedMonthEnum = "oct";
            break;
          case "11":
            selectedMonthEnum = "nov";
            break;
          case "12":
            selectedMonthEnum = "dec";
            break;
          default:
            break;
        }
        return selectedMonthEnum;
      },
      back() {
        this.toast = false;
        this.showSuccessBulkUploadMsg = false;
      },
      /** Function to fetch the paygroups data */
      async fetchPaygroupsUpdatedData() {
        try {
          let res = await this.act_fetch_paygroups_updated_data({
            le_id: this.le_id,
            processing_payroll_month: this.getSelectedMonthEnumByName(
              this.payrollMonth
            ),
            financial_year: this.payrollYear
          });
          if (res.data.status) {
            let dataArr = res.data.payload.data;
            this.setData();
          }
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      },
      async getLopRlopData() {
        try {
          let fetchMonth;
          let getYear;
          let lopMonth;
          var result = this.selectDate ? this.selectDate.split("-") : null;
          if(result !== null){
            for (var i = 0; i < this.monthOptions.length; i++) {
              if (this.monthOptions[i].key == result[1]) {
                lopMonth = this.monthOptions[i].value;
              }
            }
          }
          if(this.lopRlopType == "Day"){
            fetchMonth = this.month.toLowerCase().substring(0,3);
            getYear = this.payrollYear;
          } else {
            fetchMonth = lopMonth;
            getYear = result[0];
          }
          let obj ={
            id: this.empId,
            financial_year: getYear,
            month:fetchMonth,
          }
          if(this.typeOfLeave == "LOP"){
            obj.LOP = this.typeOfLeave
            let res = await this.act_get_lop_rlop_data(obj);
            if(res.data.status){
              if(this.lopRlopType == "Day"){
                this.lopMonthCount = res.data.payload.length > 0 ? res.data.payload[0].deduction_ratio_lop : 0;
              }else{
                this.lopMonthCountArray = res.data.payload.length > 0 ? res.data.payload.map(el => el.lop_date) : 0;
              }
            }
          }else{
            obj.RLOP = this.typeOfLeave
            let res = await this.act_get_lop_rlop_data(obj);
            if(res.data.status){
              if(this.lopRlopType == "Day"){
                this.rlopMonthCount = res.data.payload.length > 0 ? res.data.payload[0].reimbursement_ratio_rlop : 0;
              }else{
                this.rlopMonthCountArray = res.data.payload.length > 0 ? res.data.payload.map(el => el.lop_date) : 0;
              }
            }
          }
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      },
      //Function to get Lop and Rlop type from Payroll Computation 
      async fetchLopSetting(){
         try {
          let res = await this.act_fetch_lop_setting(this.le_id);
          this.lopRlopType = res.data.payload.data.lop_rlop_type;
          if(this.lopRlopType == "Day"){
            this.showDatePicker = false;
          } else{
            this.showDatePicker = true;
          }
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      },
      /** Function to get the selected month enum by Name */
      getSelectedMonthEnumByName(selectedMonth) {
        try {
          let selectedMonthEnum = "";
          switch (selectedMonth) {
            case "January":
              selectedMonthEnum = "jan";
              break;
            case "February":
              selectedMonthEnum = "feb";
              break;
            case "March":
              selectedMonthEnum = "mar";
              break;
            case "April":
              selectedMonthEnum = "apr";
              break;
            case "May":
              selectedMonthEnum = "may";
              break;
            case "June":
              selectedMonthEnum = "jun";
              break;
            case "July":
              selectedMonthEnum = "jul";
              break;
            case "August":
              selectedMonthEnum = "aug";
              break;
            case "September":
              selectedMonthEnum = "sep";
              break;
            case "October":
              selectedMonthEnum = "oct";
              break;
            case "November":
              selectedMonthEnum = "nov";
              break;
            case "December":
              selectedMonthEnum = "dec"; // PL-2264
              break;
            default:
              break;
          }
          return selectedMonthEnum; // Enum type - values :  ['jan', 'feb','mar', 'apr','may', 'jun','jul', 'aug','sep', 'oct','nov', 'dec']
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      },
      /** Function to fetch the LOPs/RLOPs data for a selected employee from server */
      async fetchAll() {
        if (this.empId) {
          try {
            let res = await this.act_fetchAll(this.empId);
            if (res.message != null) {
              throw Error(res.message);
            }
            for (var i = 0; i < res.payload.length; i++) {
              let obj = {
                lopdates: res.payload[i].lop_date,
                nooflop: res.payload[i].lop_date.length
              };
              this.employeeData.push(obj);
              // tempObj = res.data.payload.data[i].EmployeeSalarySetting[j].master_salary_structure.obj
            }
          } catch (err) {
            this.toast = true;
            this.errmsg = err.message;
          }
        }
      },
      /** Function to reset the form data */
      refresh() {
        this.typeOfLeave = null;
        this.noOfDays = "";
        this.selectDate = null;
        this.empId = null;
        this.showEmpDetails = false;
        this.month = null;
        this.lopMonthCount = null;
        this.rlopMonthCount = null;
        this.lopMonthCountArray = null;
        this.rlopMonthCountArray = null;
      },
      monthRefresh(){
        this.month = null;
        this.lopMonthCount = null;
        this.rlopMonthCount = null;
        this.lopMonthCountArray = null;
        this.rlopMonthCountArray = null;
      },
      /** Function to validate the form data */
      async add() {
        this.$validator.validateAll().then(result => {
          if (result) {
            if (this.empId) {
              this.performAction();
            } else {
              this.toast = true;
              this.errmsg = "Please select an employee";
            }
          }
        });
      },
      /** Function to submit the form data to server */
      async performAction() {
        var result = this.selectDate ? this.selectDate.split("-") : null;
        if(result !== null){
          for (var i = 0; i < this.monthOptions.length; i++) {
            if (this.monthOptions[i].key == result[1]) {
              var month = this.monthOptions[i].value;
            }
          }
        }
        let obj = {
          type: this.typeOfLeave,
          ratio: this.noOfDays,
          employee_id: this.empId,
          payroll_month: this.payrollMonth.toLowerCase().substring(0,3),
        };
        if(this.lopRlopType == "Day"){
          obj.month= this.month.toLowerCase().substring(0,3);
          obj.financial_year = this.payrollYear;
        }else{
          obj.month = month;
          obj.financial_year = result[0];
          obj.date = this.selectDate;
        }
        this.$root._data.isSaving = true;
        try {
          let res = await this.act_create(obj);
            setTimeout(() => {
              if (res.status) {
                this.responseMsg = res.data.message
                this.showSuccessBulkUploadMsg = true;
                this.typeOfLeave == 'LOP' ? this.lopCount = this.noOfDays : this.rlopCount = this.noOfDays
              }
              this.$root._data.isSaving = false;
              this.refresh();
            }, 500);
        } catch (error) {
            this.$root._data.isSaving = false;
            this.toast = true;
            this.errmsg = error;
        }
        
      },
      /** Logic to search from a certain lis of data by a specific key */
      searchData(key, array) {
        const final = [];
        for (let i = 0; i < array.length; i++) {
          let searchKey = array[i].empName;
          if (
            searchKey != null &&
            searchKey.toLowerCase().search(key.toLowerCase()) !== -1
          ) {
            final.push(array[i]);
          }
        }
        return final;
      },
      /** To filter the data based certain conditions */
      filterData(searchText) {
        let data = this.$_.cloneDeep(this.employeeData);
        if (searchText.length) {
          this.auto_suggestions = true;
          this.filterEmpData = this.searchData(searchText, this.employeeData);
        } else {
          this.auto_suggestions = false;
        }
      },
      /** To lock/unlock the 'Next' button */
      locklist(ee) {
        // this.$emit("lopsLocking", ee);
        // if(ee) {
        //   this.isLopsLocked=true;
        // }
        // else {
        //     this.isLopsLocked = false;
        // }
        ee? this.isLopsLocked = true : this.isLopsLocked = false
      },
      /** On click employee card in search */
      /** Function to set the counts of different elements in UI */
      setData() {
        let payGroupsData = this.payGroupsData[this.le_id];
        let selectedPayGroupsData = this.selectedPayGroupsData[this.le_id];
        if (payGroupsData) {
          this.countObj.totalPayGroups = payGroupsData.length;
          let totalEmployees = 0;
          let totalEligibleEmployees = 0;
          payGroupsData.forEach(item => {
            totalEmployees =
              totalEmployees + (item.totalEmployess ? item.totalEmployess : 0);
            totalEligibleEmployees =
              totalEligibleEmployees +
              (item.eligibleEmployees ? item.eligibleEmployees : 0);
          });
          this.countObj.totalEmployees = totalEmployees;
          this.countObj.totalEligibleEmployees = totalEligibleEmployees;
        }
        if (selectedPayGroupsData) {
          this.countObj.payGroupsSelected = selectedPayGroupsData.length;
          let totalEmployeesSelected = 0;
          let eligibleEmployeesSelected = 0;
          selectedPayGroupsData.forEach(item => {
            totalEmployeesSelected =
              totalEmployeesSelected +
              (item.totalEmployess ? item.totalEmployess : 0);
            eligibleEmployeesSelected =
              eligibleEmployeesSelected +
              (item.eligibleEmployees ? item.eligibleEmployees : 0);
          });
          this.countObj.totalEmployeesSelected = totalEmployeesSelected;
          this.countObj.eligibleEmployeesSelected = eligibleEmployeesSelected;
        }
        /** Set the counts of LOP and RLOP elements in UI For PL-3549*/
        this.lopCount = payGroupsData[0].lopRegistred;
        this.rlopCount = payGroupsData[0].rlopRegistred;
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  @import "@/scss/dashboard/_variables.scss"; // Common
  @import "@/scss/dashboard/content/_section.scss"; // Content Section
  .download-btn-container {
    display: flex;
    align-items: normal;
    .img {
      height: 18px;
      width: 16px;
      object-fit: contain;
    }
    .text {
      font-size: 14px;
      font-weight: 600;
      color: $color-secondary;
      margin-left: 8px;
      cursor: pointer;
    }
  }
  .paygrpsDiv {
    display: flex;
    cursor: pointer;
    padding: 40px 0px;
    span {
      color: #646464;
      font-size: 16px;
    }
    > :nth-child(n) {
      margin-right: 64px;
    }
    > :last-child {
      margin-right: 0px;
    }
  }
  .paygrps-info {
    color: #646464;
    cursor: pointer;
    text-align: center;
    margin-top: 5px;
    b {
      font-size: 24px;
      font-weight: 500;
    }
  }
  .paygrp {
    background: #fbfbfb;
    width: 31%;
    height: 85px;
    border-radius: 2px;
    border: solid 1px #37c6c0;
    padding: 20px;
    text-align: center;
    display: flex;
    justify-content: inherit;
  }
  .alignPaygrp {
    padding: 20px;
    text-align: center;
  }
  .d-marginBottom {
    margin-bottom: 7px;
  }
  // .line {
  //   border-bottom: 1px solid #c8c8c8;
  //   width: 100%;
  //   margin-bottom: 20px;
  // }
  .uploadMethoRadio {
    margin-top: 30px;
    display: flex;
    margin-bottom: 2%;
  }
  .label {
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 8px;
    color: #6e6e6e;
  }
  .download-btn {
    margin-top: 2%;
  }
  .search-result {
    position: absolute;
    width: 320px;
    background: #ffffff;
    max-height: 368px;
    border-radius: 4px;
    border: solid 1px #f7f7f7;
    overflow: auto;
    li {
      padding: 15px;
      border-bottom: 0.5px solid #e3e3e3;
      margin-right: 0px !important;
      &:hover {
        background-color: #d6f2f2;
      }
    }
  }
  .upload {
    display: flex;
    width: 30%;
    margin-top: 2%;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(
        to right,
        lightgray 10px,
        rgba(255, 255, 255, 0) 0%
      ),
      linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%),
      linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%),
      linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%);
    background-position: top, right, bottom, left;
    background-repeat: repeat-x, repeat-y;
    background-size: 20px 1px, 1px 20px;
    height: 140px;
  }
  .upload-button {
    display: flex;
    align-items: center;
    label {
      cursor: pointer;
      border: 1px solid #5d409f;
      border-radius: 4px;
      padding: 6px 12px;
      font-size: 15px;
      margin-top: 2px;
      color: #5d409f;
    }
    #upload-photo {
      opacity: 0;
      position: absolute;
      z-index: -1;
    }
    img {
      height: 19px;
      width: 19px;
      margin-right: 8px;
    }
  }
  .fourColumnGrid {
    display: grid;
    grid-template-columns: 1fr 1fr 0fr 3fr;
    // grid-template-columns: 6fr 2fr 1fr 3fr;
    grid-gap: 20px;
  }
  .line {
    padding-top: 15%;
    border-bottom: 1px solid #34c0be;
    flex-grow: 1;
    margin-top: 15%;
  }
  .btnGrp {
    float: right;
  }
  .text{
    color: #37c6c0;
  }
  .search-bar {
    width: 100%;
    border: 1px solid #d6d4d4;
    border-radius: 3px;
    height: 30px;
    padding: 5px;
    outline: none;
    position: relative;
  }
  .search-icon {
    position: absolute;
    left: 10px;
    top: 6px;
    width: 18px;
    height: 18px;
  }
  .search-container {
    position: relative;
    margin-top: 3px;
  }
  .noofdays {
    input {
      border-radius: 4px;
      border: 1px solid #dadada;
      padding: 10px;
      width: 100px;
      height: 35px;
      transition: ease-in-out, width 0.35s ease-in-out;
      &:focus {
        outline: none;
        border: 2px solid #34c0be;
      }
    }
  }
  .img-part {
    img {
      width: 100%;
    }
  }
  .typeClass {
    margin-left: 70px;
  }
  .dateCalClass {
    margin-top: 19px;
    margin-left: 15px;
  }
  .custom-txt {
    // width: 75px;
    margin-top: -1px;
    margin-left: 15px;
  }
  .filterbtn {
    width: 95px;
    height: 35px;
    border-radius: 4px;
    border: solid 1px #34c0be;
    color: #34c0be;
    cursor: pointer;
    margin-left: -15px;
    margin-bottom: 40px;
  }
  lock-list {
    span {
      margin-top: 20px;
    }
  }
  .margin-t-l-15 {
    margin-left: 0px;
  }
  </style>  